/** Un objeto por módulo. Las páginas nunca arman URLs a mano. */
import api from './client';

const data = (promise) => promise.then((r) => r.data);

export const authApi = {
  login: (email, password) => data(api.post('/auth/login', { email, password })),
  me: () => data(api.get('/auth/me')),
  changePassword: (current_password, new_password) =>
    data(api.post('/auth/change-password', { current_password, new_password })),
};

export const customersApi = {
  list: (params) => data(api.get('/customers', { params })),
  create: (body) => data(api.post('/customers', body)),
  update: (id, body) => data(api.put(`/customers/${id}`, body)),
  remove: (id) => data(api.delete(`/customers/${id}`)),
};

export const productsApi = {
  list: (params) => data(api.get('/products', { params })),
  lowStock: () => data(api.get('/products/low-stock')),
  categories: () => data(api.get('/products/categories')),
  create: (body) => data(api.post('/products', body)),
  update: (id, body) => data(api.put(`/products/${id}`, body)),
  adjustStock: (id, quantity, reason) =>
    data(api.post(`/products/${id}/adjust-stock`, { quantity, reason })),
  remove: (id) => data(api.delete(`/products/${id}`)),
};

export const salesApi = {
  list: (params) => data(api.get('/sales', { params })),
  create: (body) => data(api.post('/sales', body)),
  confirm: (id) => data(api.post(`/sales/${id}/confirm`)),
  remove: (id) => data(api.delete(`/sales/${id}`)),
};

export const expensesApi = {
  list: (params) => data(api.get('/expenses', { params })),
  categories: () => data(api.get('/expenses/categories')),
  create: (body) => data(api.post('/expenses', body)),
  update: (id, body) => data(api.put(`/expenses/${id}`, body)),
  remove: (id) => data(api.delete(`/expenses/${id}`)),
};

export const cashApi = {
  movements: (params) => data(api.get('/cash/movements', { params })),
  create: (body) => data(api.post('/cash/movements', body)),
  daily: (date) => data(api.get(`/cash/daily/${date}`)),
  balance: () => data(api.get('/cash/balance')),
  remove: (id) => data(api.delete(`/cash/movements/${id}`)),
};

export const agendaApi = {
  list: (params) => data(api.get('/agenda', { params })),
  create: (body) => data(api.post('/agenda', body)),
  update: (id, body) => data(api.put(`/agenda/${id}`, body)),
  toggle: (id) => data(api.post(`/agenda/${id}/toggle`)),
  remove: (id) => data(api.delete(`/agenda/${id}`)),
};

export const reportsApi = {
  summary: (params) => data(api.get('/reports/summary', { params })),
  today: () => data(api.get('/reports/today')),
};
